import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdowns/Dropdown';
import DropdownSection from '../Dropdowns/DropdownSection';
import Button from '../Buttons/Button';

const CommentDropdown = ({ myComment, locked, deleteComment, reportComment }) => (
  <Dropdown
    size="s"
    position="right"
  >
    {myComment &&
      <DropdownSection>
        <Button classes="dropdown-link" onClick={deleteComment} faux>Delete comment</Button>
      </DropdownSection>
    }
    {myComment === false &&
    locked === false &&
      <DropdownSection>
        <Button classes="dropdown-link" onClick={reportComment} faux>Report as inappropriate</Button>
      </DropdownSection>
    }
  </Dropdown>
);

CommentDropdown.propTypes = {
  myComment: PropTypes.bool.isRequired,
  locked: PropTypes.bool,
  deleteComment: PropTypes.func.isRequired,
  reportComment: PropTypes.func.isRequired,
};

export default CommentDropdown;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/CommentDropdown.js